import { call, put, takeEvery } from "redux-saga/effects"

import {
  UPDATE_NOTIFICATION,
} from "./actionTypes"

import {
  updateNotificationSuccess,
  updateNotificationError
} from "./actions"

import {
  genericPutRequest
} from "../../helpers/sf_backend_helper";

import { AppConfiguration } from "config";
import { getCurrentBrandFromLocalStorage } from "helpers/sf_utils"
import { getCurrentUser } from "store/actions";

// Modify Ad
function* onUpdateNotification(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/notification_preferences/${action.payload.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json',
          'brand-id': getCurrentBrandFromLocalStorage()?.id
        }
      }
    )
    yield put(updateNotificationSuccess(response))
    yield put(getCurrentUser())
  } catch (error) {
    yield put(updateNotificationError(error))
  }
}

function* NotificationsSaga() {
  yield takeEvery(UPDATE_NOTIFICATION, onUpdateNotification);
}


export default NotificationsSaga;
